export const es = {
  CANONICAL_LOCALE: "es-ES",

  "general.send": "Enviar",
  "general.cancel": "Cancelar",
  "general.apply": "Aplicar",
  "general.name": "Nombre",
  "general.privacy": "Privacidad",
  "general.recipients": "Participantes",
  "general.message": "Mensaje",
  "general.toFilter": "Buscar",
  "general.messageSingular": "mensaje",
  "general.messagePlural": "mensajes",
  "general.messageSettings": "Configuraciones de mensaje",

  "date.shortYear": "año",
  "date.shortYears": "años",
  "date.shortMonth": "mes",
  "date.shortMonths": "meses",
  "date.shortDay": "dia",
  "date.shortDays": "dias",
  "date.shortHour": "h",
  "date.shortMinute": "m",
  "date.now": "ahora",
  "date.today": "Hoy",
  "date.yesterday": "Ayer",
  "date.start": "Inicio",
  "date.end": "Final",

  "filter.filterByPeriod": "Filtrar por periodo",
  "filter.filterByProcess": "Filtrar por proceso",
  "filter.filterByRecipient": "Filtrar por participantes",
  "filter.clearFilters": "Limpiar filtros",
  "filter.filterByFlag": "Filtrar por marcador",
  "filter.searchIn": "Buscar en {name}",
  "filter.numberOfactiveMessages": "{number} {sufix}",
  "filter.noMessages": "No hay",
  "filter.allActiveMessages": "Todos los mensajes activos",
  "filter.allActiveMessages.sufixForLabels": "mensajes activos",
  "filter.allActiveMessages.sufixForLabels.singular": "mensaje activo",
  "filter.archivedMessages": "Sólo archivados",
  "filter.archivedMessages.sufixForLabels": "mensajes archivados",
  "filter.archivedMessages.sufixForLabels.singular": "mensaje archivado",
  "filter.allMessages": "Todos los activos y archivados",
  "filter.allMessages.sufixForLabels": "mensajes",
  "filter.allMessages.sufixForLabels.singular": "mensaje",
  "filter.messagesOpenedByMe": "Abiertas por mí",
  "filter.messagesOpenedByMe.sufixForLabels": "mensajes abiertos por mí",
  "filter.messagesOpenedByMe.sufixForLabels.singular": "mensaje abierto por mí",
  "filter.allFinilizedTasks": "Sólo tareas finalizadas",
  "filter.allFinilizedTasks.sufixForLabels": "tareas finalizadas",
  "filter.allFinilizedTasks.sufixForLabels.singular": "tarea finalizada",

  "chat.messages": "Mensajes",
  "chat.settings": "Configuraciones",
  "chat.chatSettings": "Configuraciones de mensajes",
  "chat.userNotFound": "Usuario no encontrado",
  "chat.typeUserName": "Escriba el nombre del usuario",
  "chat.typeMessage": "Escribrir mensaje...",
  "chat.sendTo": "Enviar para...",
  "chat.optionalTitle": "Titulo (opcional)",
  "chat.archiveMessage": "Archivar mensaje",
  "chat.newMessage": "Nuevo mensaje",
  "chat.newChat": "Nueva conversación",
  "chat.noDescriptionTitle": "{archived} {name} y más {number}",
  "chat.archivedPrefix": "(archivado)",
  "chat.optional": "(opcional) ",
  "chat.noOptionsAvailable": "Ninguna opcione disponible",
  "chat.newMessagesReceived": "Recibió {number} {messagePlural}",
  "chat.noFlag": "Sin marcador",
  "chat.flag": "Marcador",
  "chat.task": "Tarea",
  "chat.flagFinalize": 'Finalizar "{flag}"',
  "chat.finalizedPrefix": "(finalizada)",

  "message.empty": "Comuníquese com el equipo",
  "message.empty.description":
    "Escriba mensajes para sanar dudas con alguien o con más participantes.",
  "message.error": "Se ha producido un error en el sistema",
  "message.error.description":
    "No se pudo cargar el contenido. Compruebe su conexión, actualice la página o vuelva a intentarlo en un momento.",
  "message.noResults": "No hay mensajes encontrados",
  "message.noResults.description":
    "Modifique los filtros o escriba un nuevo mensaje.",

  "privacy.public": "Pública",
  "privacy.public.description":
    "Puede ser visualizada por todos os usuarios que tienen permiso para acceder al proceso",
  "privacy.participants": "Participantes",
  "privacy.participants.description":
    "Enviado a los destinatarios y responsables del proceso.",
  "privacy.private": "Privada",
  "privacy.private.description": "Enviado sólo a los destinatarios.",

  "settings.inbox": "Caja de entrada de mensajes",
  "settings.sendMessage": "Envío de mensaje",
  "settings.notifications": "Noticaciones",
  "settings.dynamicMessage": "Filtro dinámico de mensajes",
  "settings.dynamicMessage.description":
    "Siempre que navegar o pulsar en un proceso o actividad, los mensajes vinculadas a ellos filtrarán automáticamente. Los filtros se aplicarán normalmente.",
  "settings.alwaysOpenNewMessages": "Siempre abrir nuevos mensajens",
  "settings.alwaysOpenNewMessages.description":
    "Al llegar nuevos mensajes, automáticamente se abrirán en uma área.",
  "settings.pressEnterToSendMessage": "Pulse la tecla enter para enviar",
  "settings.pressEnterToSendMessage.description":
    "El envio de las respuestas en una mensaje serán hechas por la tecla Enter e no más haciendo clic em él botón Enviar. Esa acione no cambia el botón Enviar na creación de nuevas conversaciones.",
  "settings.receiveEmailNotifications":
    "Recibir notificaciones por correo electrónico",
  "settings.receiveEmailNotifications.description":
    "Recibir notificaciones de nuevos mensajes por correo electrónico.",
  "settings.more": "Más configuraciones",

  "error.reconnectingIn": "Reconectando en {seconds} segundo(s)",
  "error.reconnecting": "Reconectando...",
  "error.connectionLost": "Conexión perdida",

  "profiles.manager": "Gerente",
  "profiles.last-approver": "Último_aprobador",
};
